import { Icon } from "@chakra-ui/react";
import React from "react";

const CircleIcon = (props) => (
  <Icon viewBox="0 0 5 5" {...props}>
    <g fill="currentColor" stroke="currentColor" strokeWidth="1">
      <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
      <circle cx="2.5" cy="2.5" r="2" fill="none" />
    </g>
  </Icon>
);

export default React.memo(CircleIcon);
